import { Spinner, Toggle } from 'aimo-ui';
import useMinimumLoadingTime from 'hooks/useMinimumLoadingTime';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { testIdentifiers } from 'utils/testIdentifiers';
import { MenuItemWrapped } from './MenuComponents';

type MenuToggleItemProps = {
  value: boolean;
  onValueChange: (value: boolean) => void;
  testID: string;
  subtitle?: string;
  menuLabel: string;
  iconName?: string;
  loading?: boolean;
  disabled?: boolean;
  color?: string;
  noBorder?: boolean;
};

const MenuToggleItem: React.FC<MenuToggleItemProps> = ({
  value,
  onValueChange,
  testID,
  subtitle,
  menuLabel,
  iconName,
  loading,
  disabled,
  color,
  noBorder = false,
}: MenuToggleItemProps) => {
  const { t } = useTranslation();
  const { showLoading } = useMinimumLoadingTime(loading ?? false, 1500, 200);

  return (
    <MenuItemWrapped
      menuLabel={t(menuLabel)}
      iconName={iconName}
      testID={`${testID}-menu-item`}
      subtitle={subtitle}
      color={color}
      containsInteractiveElement={true}
      noBorder={noBorder}
      rightComponent={
        showLoading ? (
          <Spinner size={35} />
        ) : (
          <Toggle
            disabled={disabled}
            {...testIdentifiers(`${testID}-toggle`)}
            value={value}
            onValueChange={onValueChange}
            accessible={true}
            accessibilityLabel={subtitle}
            accessibilityState={{ checked: value, disabled }}
          />
        )
      }
      withArrow={false}
    />
  );
};

export default MenuToggleItem;
